import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './UserListItem';

import UserActions from '../../actions/UserActionCreator';
import TrainerStore from '../../stores/TrainerStore';

import ScheduleIcon from 'material-ui/svg-icons/communication/clear-all';
import CalendarIcon from 'material-ui/svg-icons/action/date-range';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

import buildContextMenu from '../Common/BuildContextMenu';

class TrainerList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            users: [],
            actions: [],
            sortCriteria: null,
            sortMapCriteria: null
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.sort = this.sort.bind(this);

        TrainerStore.addChangeListener(this.onChange);
        UserActions.getTrainers();
        this.setState({actions: buildContextMenu(this.getActions(), this.context.auth)});
    }

    componentWillUnmount() {
        TrainerStore.removeChangeListener(this.onChange);
    }

    getActions() {
        return [
            {
                link: '/dashboard/trainers/events',
                icon: <CalendarIcon />,
                label: 'Calendar',
            },
            {
                link: '/dashboard/trainers/schedule',
                icon: <ScheduleIcon />,
                label: 'Schedule',
            },
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            },
        ];
    }

    render() {

        return (
            <ListView
                title="Trainers"
                sortOptions={this.props.sortOptions}
                sortAction={this.sort}
                searchAction={UserActions.searchTrainers}
                actions={this.state.actions}
                items={this.state.users}
                itemDecorator={ListItem}
            />

        );
    }

    onChange() {
        const users = TrainerStore.getAll();
        if (!!users) {
            if (users.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({users});
            } else {
                const mapped = users.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sortedUsers= mapped.map((el) => users[el.index]);
                this.setState({users: sortedUsers});
            }
        }
    }

    sort(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'firstName':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.firstName});
                break;
            case 'lastName':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.lastName});
                break;
            case 'jobRole':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.jobRole});
                break;
            case 'visits':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Number(el.visits)});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria});
        UserActions.getTrainers({sort: options.sort});
    }
}

TrainerList.defaultProps = {
    sortOptions: [
        {label: "First name", value: 'firstName'},
        {label: "Last name", value: 'lastName'},
        {label: "Job role", value: 'jobRole'},
        {label: "Visits", value: 'visits'}
    ]
};

TrainerList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default TrainerList;
